import React, { useEffect, useState } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import FlowBuilder from "../FlowBuilder/FlowBuilder";
import CircularProgress from "@mui/material/CircularProgress";

import { useDispatch, useSelector } from "react-redux";

import "./CreateDataMapping.css";

import {
  getCRMData,
  getDestTableColumns,
  getDestTables,
  getSalesForceData,
  sendSoucerCSVData,
  sendSoucerData,
  submitDataMapping,
} from "../../apis/dataMapping/dataMapping";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type DestTableList = {
  Id: number;
  Table_Name: string;
}[];
type DestColumnList = {
  Name: string;
  Type: string;
}[];

function CreateDataMapping() {
  const [loading, setLoading] = React.useState(false);
  const [showFlowDiv, setShowFlowDiv] = React.useState(false);
  const EmpId = useSelector((state: any) => state.authApiSlice.Id);
  const [appFlowData, setAppFlowData] = React.useState<any>([]);
  const ActiveClient = useSelector(
    (state: any) => state.clientDetails.activeClient
  );
  const [selectedEnv, setSelectedEnv] = useState<any>("");

  const [currentSlide, setCurrentSlide] = useState(1);
  const [currentSlideTitle, setCurrentSlideTitle] =
    useState("Select Data Source");
  const [sourceTableStructure, setSourceTableStructure] = useState<any>(null);
  const [sourceDataId, setSourceDataId] = useState<any>(null);
  const [destinationTableStructure, setDestinationTableStructure] =
    useState<any>(null);
  const [selectedDestinationTable, setSelectedDestinationTable] =
    useState<any>(null);
  const [selectedSourceType, setSelectedSourceType] = useState("Excel");
  const [dm_body_div_height, setDm_body_div_height] = useState("");
  const [dataMappingJson, setDataMappingJson] = useState<any>(null);
  const [data2, setData2] = useState(null);
  const [data3, setData3] = useState(null);

  //Destination tables vars
  const [destTableList, setDestTableList] = useState<DestTableList | null>(
    null
  );
  const [destColumnList, setDestColumnList] = useState<DestColumnList | null>(
    null
  );

  //Query  vars
  const [S_tableName, setS_tableName] = useState("");
  const [columnList, setColumnList] = useState<any>([""]);
  const [queryCondition, setQueryCondition] = useState("");
  const [orderByCondition, setOrderByCondition] = useState("");

  //salesforce vars
  const [salesforceClientId, setSalesforceClientId] = useState("");
  const [salesforceClientSecret, setSalesforceClientSecret] = useState("");
  const [salesforceUsername, setSalesforceUsername] = useState("");
  const [salesforcePassword, setSalesforcePassword] = useState("");

  //crm vars
  const [CRMClientId, setCRMClientId] = useState("");
  const [CRMClientSecret, setCRMClientSecret] = useState("");
  const [CRMTenentId, setCRMTenentId] = useState("");
  const [CRMResourceUrl, setCRMResourceUrl] = useState("");

  useEffect(() => {
    const dm_body_height: any = document.getElementById(
      "dm-center-div-Wrapper"
    );

    //seting table height by subtracting padding space
    setDm_body_div_height(
      `${
        dm_body_height.clientHeight - (dm_body_height.clientHeight * 5) / 100
      }px`
    );

    setSelectedEnv(ActiveClient.Env_Data[0]);
  }, []);

  const handleChangeEnv = (val: any) => {
    setSelectedEnv(val);
    setCurrentSlide(1);
  };

  const handleNext = async () => {
    if (currentSlide === 1) {
      if (selectedSourceType === "Excel") {
        const fileInput: any = document.getElementById("sourceFile");
        var soucreFile = fileInput.files[0];
        let data = new FormData();
        data.append("Client_Id", ActiveClient.Client_Id);
        data.append("Env_Id", ActiveClient.Env_Data[0].Env_Id);
        data.append("file", soucreFile);

        sendSoucerData(data, (res: any) => {
          console.log("Source Data submitted --", res);
          setSourceTableStructure(res.Table_Structure);
          setSourceDataId(res.Id);
          getDestTables((res: any) => {
            setDestTableList(res.data);
            setCurrentSlide((prevSlide) => prevSlide + 1);
            setCurrentSlideTitle("Select Table Mapping");
          });
        });
      } else if (selectedSourceType === "CSV") {
        const fileInput: any = document.getElementById("sourceCSVFile");
        var soucreFile = fileInput.files[0];
        let data = new FormData();
        data.append("Client_Id", ActiveClient.Client_Id);
        data.append("Env_Id", ActiveClient.Env_Data[0].Env_Id);
        data.append("file", soucreFile);

        sendSoucerCSVData(data, (res: any) => {
          console.log("Source CSV Data submitted --", res);
          setSourceTableStructure(res.Table_Structure);
          setSourceDataId(res.Id);
          getDestTables((res: any) => {
            setDestTableList(res.data);
            setCurrentSlide((prevSlide) => prevSlide + 1);
            setCurrentSlideTitle("Select Table Mapping");
          });
        });
      } else if (selectedSourceType === "Salesforce") {
        let queryColumns = "";
        columnList.map((el: string) => {
          if (queryColumns.length == 0) {
            queryColumns = el;
          } else {
            queryColumns = queryColumns.concat(",", el);
          }
        });
        let whereCondition =
          queryCondition.length > 0 ? `WHERE ${queryCondition}` : "";
        let query = `SELECT ${queryColumns} FROM ${S_tableName} ${whereCondition}`;
        let s_data_structure = {
          Table_Name: S_tableName,
          Column_List: columnList,
        };

        let payload = {
          Client_Id: ActiveClient.Client_Id,
          Env_Id: ActiveClient.Env_Data[0].Env_Id,
          salesforce_q: query,
          salesforce_clientId: salesforceClientId,
          salesforce_clientSecret: salesforceClientSecret,
          salesforce_username: salesforceUsername,
          salesforce_password: salesforcePassword,
          Table_Structure: s_data_structure,
        };
        console.log("Salesforce Data  --", payload);
        getSalesForceData(payload, (res: any) => {
          console.log("Salesforce Data submitted --", res);
          setSourceTableStructure(res.Table_Structure);
          setSourceDataId(res.Id);
          getDestTables((res: any) => {
            setDestTableList(res.data);
            setCurrentSlide((prevSlide) => prevSlide + 1);
            setCurrentSlideTitle("Select Table Mapping");
          });
        });
      } else if (selectedSourceType === "Microsoft Dynamics(CRM)") {
        let queryColumns = "";
        columnList.map((el: string) => {
          if (queryColumns.length == 0) {
            queryColumns = el;
          } else {
            queryColumns = queryColumns.concat(",", el);
          }
        });
        let s_data_structure = {
          Table_Name: S_tableName,
          Column_List: columnList,
        };

        let payload = {
          Client_Id: ActiveClient.Client_Id,
          Env_Id: ActiveClient.Env_Data[0].Env_Id,
          crm_clientId: CRMClientId,
          crm_tenentId: CRMTenentId,
          crm_clientSecret: CRMClientSecret,
          crm_url: CRMResourceUrl,
          Table_Structure: s_data_structure,
          table_name: "contacts",
          select: queryColumns,
          conditions:queryCondition,
          order_conditions:orderByCondition
        };
        console.log("crm Data  --", payload);
        await getCRMData(payload, (res: any) => {
          console.log("crm Data submitted --", res);
          setSourceTableStructure(res.Table_Structure);
          setSourceDataId(res.Id);
          getDestTables((res: any) => {
            setDestTableList(res.data);
            setCurrentSlide((prevSlide) => prevSlide + 1);
            setCurrentSlideTitle("Select Table Mapping");
          });
        });
      }

      let destinationTBStructure = [
        {
          Table_Name: "Ref_Prescriber",
          Column_List: [
            "PrescriberNationalProv_Id",
            "Prescriber_Typ",
            "PrescriberIntlCallPfx_Nbr",
            "PrescriberAcctCust_Nm",
            "PrescriberAcctPfx_Cd",
            "PrescriberAcct1st_Nm",
            "PrescriberAcctMid_Nm",
            "PrescriberAcctLast_Nm",
            "PrescriberAcctSfx_Cd",
            "PrescriberAcctProSfx_Cd",
            "PrescriberAcctFull_Nm",
            "PrescriberAcctGndr_Cd",
            "PrescriberAcctPh_Nbr",
            "PrescriberVPH_Nbr",
            "PrescriberAcctEmail_Adr",
            "PrescriberAcctVEmail_Adr",
            "PrescriberAcctVCardSent_Flg",
            "ExternalAppPresciber_Id",
          ],
        },
      ];
      setDestinationTableStructure(destinationTBStructure);
    } else if (currentSlide === 2) {
      let payload = {
        Id: selectedDestinationTable.Id,
      };
      getDestTableColumns(payload, (res: any) => {
        setDestColumnList(res.data);

        let desttableData = res.data;

        let ColumnObj: any = {};
        desttableData.forEach((element: any) => {
          ColumnObj[element.Name] = false;
        });
        let dataMappingObj = {
          Table_Mapping: {
            Source: sourceTableStructure.Table_Name,
            Destination: selectedDestinationTable.Table_Name,
          },
          Column_Mapping: ColumnObj,
        };
        setDataMappingJson(dataMappingObj);

        setCurrentSlide((prevSlide) => prevSlide + 1);
        setCurrentSlideTitle("Select Column Mapping");
      });
    }
  };

  const handleTableChange = (souceTableName: string, desttableData: any) => {
    setSelectedDestinationTable(desttableData);
  };
  const handleColumnChange = (souceColumnName: string, destColumnName: any) => {
    let dmObj = JSON.parse(JSON.stringify(dataMappingJson));
    let columnMappingList = dmObj.Column_Mapping;

    //reset to false if souceColumnName is already asssigned
    for (const [key, value] of Object.entries(columnMappingList)) {
      if (value === souceColumnName) {
        columnMappingList[key] = false;
      }
    }


    columnMappingList[destColumnName] = souceColumnName;
    dmObj["Column_Mapping"] = columnMappingList;
    setDataMappingJson(dmObj);

    //updated destColumnList for validation if it is inUse or not
    const columnList:any = JSON.parse(JSON.stringify(destColumnList));
    columnList.map((item:any)=>{
      for (const [key, value] of Object.entries(columnMappingList)) {
        if(key === item.Name){
          if(value)
          item.inUse= true;
          else
          item.inUse= false;
        }
      }
  
    })
    setDestColumnList(columnList);
  };

  const handleAddQueryColumn = () => {
    setColumnList((current: any) => [...current, ""]);
  };
  const handleQueryColumnChange = (value: any, i: any) => {
    const newColumnList = Array.from(columnList);
    newColumnList[i] = value;
    setColumnList(newColumnList);
  };

  const getConfigDetails = (sourceType: string) => {
    let configObj: any = {};
    if (sourceType === "Salesforce") {
      configObj["salesforceClientId"] = salesforceClientId;
      configObj["salesforceClientSecret"] = salesforceClientSecret;
      configObj["salesforceUsername"] = salesforceUsername;
      configObj["salesforcePassword"] = salesforcePassword;
    } else if (sourceType === "Microsoft Dynamics(CRM)") {
      configObj["CRMClientId"] = CRMClientId;
      configObj["CRMClientSecret"] = CRMClientSecret;
      configObj["CRMTenentId"] = CRMTenentId;
      configObj["CRMResourceUrl"] = CRMResourceUrl;
    }
    return configObj;
  };

  const handleFinish = () => {
    // Perform any actions when the user finishes the slides
    let congifDetails = getConfigDetails(selectedSourceType);
    let payload = {
      Emp_Id: 1000,
      Client_Id: ActiveClient.Client_Id,
      Env_Id: selectedEnv.Env_Id,
      Env_Name: selectedEnv.Env_Name,
      Source_Data_Id: sourceDataId,
      Data_Mapping_Structure: dataMappingJson,
      Source_Type: selectedSourceType,
      Configurations: congifDetails,
    };
    console.log("Data Mapping submitted --", payload);

    submitDataMapping(payload, (res: any) => {
      if(res){
        console.log("Data Mapping submitted --", res);
        console.log("Finished!");
        setCurrentSlide(1);
      }
  
    });
  };

  return (
    <>
          <div className="tab-page-layout-1-list-header ">
            <div className="tab-page-layout-1-li-item  font-bold">
              Step {currentSlide} : {currentSlideTitle}
            </div>
            <div className='evn-dropdown-div pd-md'>
              { ActiveClient.Env_Data.length > 1 &&
              <>
                <div className='export-flow-title primary-color pd-md'>Env</div>
                <FormControl fullWidth>
                 
                  {/* <InputLabel id="select-env-label">Env</InputLabel> */}
                  <Select
                    labelId="select-env-label"
                    id="select-env-flow"
                    className="select-env-dropdown"
                    value={selectedEnv}
                    onChange={(e)=>handleChangeEnv(e.target.value)}
                  >
                    { ActiveClient.Env_Data?.map((items:any) => {
                      return (
                        <MenuItem key={ items.Env_Id } value={items}>{items.Env_Name }</MenuItem>)
                    })}
                  </Select>
                </FormControl>

                </>
                  }
            </div>
          </div>

          <div className="dm-center-div-Wrapper" id="dm-center-div-Wrapper">
            {currentSlide === 1 && (
              <div className="dm-center-div">
                <div className="navbar-sourcedata-container">
                  <div
                    className={`dm-sidenave-tab ${
                      selectedSourceType === "Excel" ? "active-sourcetype" : ""
                    }`}
                    onClick={() => setSelectedSourceType("Excel")}
                  >
                    Excel
                  </div>
                  <div
                    className={`dm-sidenave-tab ${
                      selectedSourceType === "CSV" ? "active-sourcetype" : ""
                    }`}
                    onClick={() => setSelectedSourceType("CSV")}
                  >
                    CSV
                  </div>
                  <div
                    className={`dm-sidenave-tab ${
                      selectedSourceType === "Microsoft Dynamics(CRM)"
                        ? "active-sourcetype"
                        : ""
                    }`}
                    onClick={() =>
                      setSelectedSourceType("Microsoft Dynamics(CRM)")
                    }
                  >
                    Microsoft Dynamics(CRM)
                  </div>
                  <div
                    className={`dm-sidenave-tab ${
                      selectedSourceType === "Salesforce"
                        ? "active-sourcetype"
                        : ""
                    }`}
                    onClick={() => setSelectedSourceType("Salesforce")}
                  >
                    Salesforce
                  </div>
                </div>

                <>
                  {selectedSourceType === "Excel" && (
                    <div className="dm-center-div-body">
                      <div className="text-center">
                        <input
                          type="file"
                          id="sourceFile"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        />
                      </div>
                    </div>
                  )}
                  {selectedSourceType === "CSV" && (
                    <div className="dm-center-div-body">
                      <div className="text-center">
                        <input type="file" id="sourceCSVFile" accept=".csv" />
                      </div>
                    </div>
                  )}
                  {selectedSourceType === "Microsoft Dynamics(CRM)" && (
                    <div
                      className="dm-center-div-body"
                      style={{ height: dm_body_div_height }}
                    >
                      <div className="connection-data-container">
                        <div className="section-title font-md text-center">
                          CRM Conncetion Details
                        </div>
                        <div className="dm-connection-input-section">
                          <div className="input-div">
                            <label
                              className="floating-label"
                              htmlFor="client-name-input"
                            >
                              Client Id
                            </label>
                            <input
                              id="client-name-input"
                              className="input-field-1"
                              required
                              type="text"
                              onChange={(e) => setCRMClientId(e.target.value)}
                            />
                          </div>
                          <div className="input-div">
                            <label
                              className="floating-label"
                              htmlFor="client-name-input"
                            >
                              Client Secret
                            </label>
                            <input
                              id="client-name-input"
                              className="input-field-1"
                              required
                              type="text"
                              onChange={(e) =>
                                setCRMClientSecret(e.target.value)
                              }
                            />
                          </div>
                          <div className="input-div">
                            <label
                              className="floating-label"
                              htmlFor="client-name-input"
                            >
                              Tenent Id
                            </label>
                            <input
                              id="client-name-input"
                              className="input-field-1"
                              required
                              type="text"
                              onChange={(e) => setCRMTenentId(e.target.value)}
                            />
                          </div>
                          <div className="input-div">
                            <label
                              className="floating-label"
                              htmlFor="client-name-input"
                            >
                              Resource URL
                            </label>
                            <input
                              id="client-name-input"
                              className="input-field-1"
                              required
                              type="text"
                              onChange={(e) =>
                                setCRMResourceUrl(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="query-data-container">
                        <div className="section-title font-md text-center">
                          Query Details
                        </div>
                        <div className="dm-connection-input-section dm-table-input">
                          <div className="input-div">
                            <label
                              className="floating-label"
                              htmlFor="client-name-input"
                            >
                              Table Name
                            </label>
                            <input
                              id="client-name-input"
                              className="input-field-1"
                              required
                              type="text"
                              onChange={(e) => setS_tableName(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="dm-column-input">
                          <div className="column-title-container">
                            <div className="section-title font-md align-l">
                              Columns
                            </div>
                            <div
                              className="section-title font-sm align-r add-env-btn"
                              onClick={handleAddQueryColumn}
                            >
                              <div className="add-icon">
                                <FontAwesomeIcon icon={["fas", "plus"]} />
                              </div>
                              <div>Add Column</div>
                            </div>
                          </div>
                          <div className="dm-connection-input-section">
                            {columnList.map((currentValue: string, i: any) => (
                              <div className="input-div" key={i}>
                                <label
                                  className="floating-label"
                                  htmlFor="client-name-input"
                                >
                                  Column {i + 1}
                                </label>
                                <input
                                  id="client-name-input"
                                  className="input-field-1"
                                  required
                                  type="text"
                                  onChange={(e) =>
                                    handleQueryColumnChange(e.target.value, i)
                                  }
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="dm-condition-input">
                          <div className="column-title-container">
                            <div className="section-title font-md align-l">
                              Query Conditions
                            </div>
                          </div>
                          <div className="dm-connection-input-section">
                            
                              <div className="input-div" >
                                <label
                                  className="floating-label"
                                  htmlFor="client-name-input"
                                >
                                  Conditions (Example: statecode eq 0 and postalcode eq '345677') 
                                </label>
                                <input
                                  id="client-name-input"
                                  className="input-field-1"
                                  required
                                  type="text"
                                  onChange={(e) =>
                                    setQueryCondition(e.target.value)
                                  }
                                />
                              </div>
                              <div className="input-div" >
                                <label
                                  className="floating-label"
                                  htmlFor="client-name-input"
                                >
                                  Order by (Example: name asc)
                                </label>
                                <input
                                  id="client-name-input"
                                  className="input-field-1"
                                  required
                                  type="text"
                                  onChange={(e) =>
                                    setOrderByCondition(e.target.value)
                                  }
                                />
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {selectedSourceType === "Salesforce" && (
                    <div
                      className="dm-center-div-body"
                      style={{ height: dm_body_div_height }}
                    >
                      <div className="connection-data-container">
                        <div className="section-title font-md text-center">
                          Salesforce Conncetion Details
                        </div>
                        <div className="dm-connection-input-section">
                          <div className="input-div">
                            <label
                              className="floating-label"
                              htmlFor="client-name-input"
                            >
                              Client Id
                            </label>
                            <input
                              id="client-name-input"
                              className="input-field-1"
                              required
                              type="text"
                              onChange={(e) =>
                                setSalesforceClientId(e.target.value)
                              }
                            />
                          </div>
                          <div className="input-div">
                            <label
                              className="floating-label"
                              htmlFor="client-name-input"
                            >
                              Client Secret
                            </label>
                            <input
                              id="client-name-input"
                              className="input-field-1"
                              required
                              type="text"
                              onChange={(e) =>
                                setSalesforceClientSecret(e.target.value)
                              }
                            />
                          </div>
                          <div className="input-div">
                            <label
                              className="floating-label"
                              htmlFor="client-name-input"
                            >
                              Username
                            </label>
                            <input
                              id="client-name-input"
                              className="input-field-1"
                              required
                              type="text"
                              onChange={(e) =>
                                setSalesforceUsername(e.target.value)
                              }
                            />
                          </div>
                          <div className="input-div">
                            <label
                              className="floating-label"
                              htmlFor="client-name-input"
                            >
                              Password
                            </label>
                            <input
                              id="client-name-input"
                              className="input-field-1"
                              required
                              type="text"
                              onChange={(e) =>
                                setSalesforcePassword(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="query-data-container">
                        <div className="section-title font-md text-center">
                          Query Details
                        </div>
                        <div className="dm-connection-input-section dm-table-input">
                          <div className="input-div">
                            <label
                              className="floating-label"
                              htmlFor="client-name-input"
                            >
                              Table Name
                            </label>
                            <input
                              id="client-name-input"
                              className="input-field-1"
                              required
                              type="text"
                              onChange={(e) => setS_tableName(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="dm-column-input">
                          <div className="column-title-container">
                            <div className="section-title font-md align-l">
                              Columns
                            </div>
                            <div
                              className="section-title font-sm align-r add-env-btn"
                              onClick={handleAddQueryColumn}
                            >
                              <div className="add-icon">
                                <FontAwesomeIcon icon={["fas", "plus"]} />
                              </div>
                              <div>Add Column</div>
                            </div>
                          </div>
                          <div className="dm-connection-input-section">
                            {columnList.map((currentValue: string, i: any) => (
                              <div className="input-div" key={i}>
                                <label
                                  className="floating-label"
                                  htmlFor="client-name-input"
                                >
                                  Column {i + 1}
                                </label>
                                <input
                                  id="client-name-input"
                                  className="input-field-1"
                                  required
                                  type="text"
                                  onChange={(e) =>
                                    handleQueryColumnChange(e.target.value, i)
                                  }
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="dm-condition-input">
                          <div className="column-title-container">
                            <div className="section-title font-md align-l">
                              Query Conditions
                            </div>
                          </div>
                          <div className="dm-connection-input-section">
                            <div className="input-div">
                              <label
                                className="floating-label"
                                htmlFor="client-name-input"
                              >
                                {
                                  "Conditions (Example: NAME LIKE '%sam%' OR AGE < 25)"
                                }
                              </label>
                              <input
                                id="client-name-input"
                                className="input-field-1"
                                required
                                type="text"
                                onChange={(e) =>
                                  setQueryCondition(e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              </div>
            )}
            {currentSlide === 2 && (
              <div className="dm-center-div">
                <div className="navbar-sourcedata-container"></div>
                <div className="dm-center-div-body">
                  <div
                    className="table-container"
                    style={{ height: dm_body_div_height }}
                  >
                    <table id="DM-tables">
                      <tr>
                        <th>Source Table</th>
                        <th>Destination Table</th>
                      </tr>
                      <tr>
                        <td>{sourceTableStructure.Table_Name}</td>
                        <td>
                          <FormControl className="env-type-div" size="small"
                          sx={{
                            minWidth: 300,
                          }} >
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              onChange={(e) =>
                                handleTableChange(
                                  sourceTableStructure.Table_Name,
                                  e.target.value
                                )
                              }
                              className="env-type-dropdown"
                            >
                              {destTableList?.map((item: any) => {
                                return (
                                  <MenuItem key={item.Table_Name} value={item}>
                                    {item.Table_Name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            )}
            {currentSlide === 3 && (
              <div className="dm-center-div">
                <div className="navbar-sourcedata-container">
                  <div className="input-div pd-2">
                    <label
                      className="floating-label"
                      htmlFor="client-name-input"
                    >
                      Data Mapping Name
                    </label>
                    <input
                      id="client-name-input"
                      className="input-field-1"
                      required
                      type="text"
                      // onChange={(e) => setClientName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="dm-center-div-body">
                  <div
                    className="table-container"
                    style={{ height: dm_body_div_height }}
                  >
                    <table id="DM-tables">
                      <tr>
                        <th>Source Column</th>
                        <th>Destination Column</th>
                      </tr>
                      {sourceTableStructure.Column_List.map(
                        (sourceColumnItem: any) => (
                          <tr key={sourceColumnItem}>
                            <td>{sourceColumnItem}</td>
                            <td>
                              <FormControl
                                className="env-type-div"
                                size="small"
                                sx={{
                                  minWidth: 300,
                                }}
                              >
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  onChange={(e) =>
                                    handleColumnChange(
                                      sourceColumnItem,
                                      e.target.value
                                    )
                                  }
                                  className="env-type-dropdown"
                                >
                                  {destColumnList &&
                                    destColumnList.map(
                                      (destColumnItem: any, i: any) => {
                                        return (
                                          <MenuItem
                                            key={i}
                                            value={destColumnItem.Name}
                                            disabled={("inUse" in destColumnItem && destColumnItem.inUse)}
                                          >
                                            {destColumnItem.Name}{" "}
                                            {destColumnItem.Type}
                                          </MenuItem>
                                        );
                                      }
                                    )}
                                </Select>
                              </FormControl>
                            </td>
                          </tr>
                        )
                      )}
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="tab-page-layout-1-list-footer dm-footer">
            {currentSlide < 3 && (
              <button
                className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn"
                onClick={handleNext}
              >
                <div>Next</div>
              </button>
            )}
            {currentSlide === 3 && (
              <button
                className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn"
                onClick={handleFinish}
              >
                <div>Finish</div>
              </button>
            )}
          </div>
    </>
  );
}

export default CreateDataMapping;
